var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#FFC800"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 27.5C38 27.5 28 37.5 28 50C28 62.5 38 72.5 50.5 72.5C63 72.5 73 62.5 73 50C73 37.5 63 27.5 50.5 27.5ZM50.5 68.25C40.5 68.25 32.5 60 32.5 50C32.5 40 40.5 32 50.5 32C60.5 32 68.75 40.25 68.75 50.25C68.75 60 60.5 68.25 50.5 68.25Z",
    fill: "#28303F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58 47.75H52.75V37.5C52.75 36.25 51.75 35.25 50.5 35.25C49.25 35.25 48.25 36.25 48.25 37.5V49.5C48.25 51 49.5 52.25 51 52.25H58C59.25 52.25 60.25 51.25 60.25 50C60.25 48.75 59.25 47.75 58 47.75Z",
    fill: "#28303F"
  })));
};
export default SvgWarning;